import remote from './remote';

const createFormData = params => {
  const formData = new FormData();
  Object.keys(params.data).forEach(key => {
    const value = params.data[key];
    if (value && typeof value === 'object') {
      formData.append(key, JSON.stringify(value));
    } else {
      formData.append(key, value);
    }
  });
  return formData;
};

const createSaveResponse = response => {
  // if (response.hasErrors) {
  //   store.dispatch(showNotification(`${response.errors.join('\n')}`, 'warning'));
  //   // throw to trigger promise on failure rather than on success
  //   throw new Error(response.errors.join('\n'));
  // }
  // if (response.infos && response.infos.length > 0) {
  //   store.dispatch(showNotification(`${response.infos.join('\n')}`));
  // }
  let resp = { data: { id: response.objectId } };
  if (response.infos) {
    resp = {
      ...resp,
      infos: response.infos,
    };
  }
  return resp;
};

export default mapping => {
  return {
    getList: (resource, params) => {
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      let url = `${mapping[resource]}/${resource}?currentpage=${page}&perPage=${perPage}&sortBy=${field}&sortOrd=${order}`;
      if (params.filter) {
        const filters = Object.keys(params.filter).map(x => {
          return `&${x}=${params.filter[x]}`;
        });
        url = `${url}${filters.join('')}`;
      }

      return remote.get(url).then(({ data, count }) => ({
        data: data.map(x => (x.object ? x.object : x)),
        total: count,
      }));
    },

    getOne: (resource, params) => {
      const url = `${mapping[resource]}/${resource}/${params.id ? params.id : ''}`;
      return remote.get(url).then(response => {
        let obj = { id: params.id };
        response.fields.map(field => {
          if (field.isJson) {
            obj[field.name] = JSON.parse(field.value);
          } else {
            obj[field.name] = field.value;
          }
          return null;
        });

        for (let i = 0; i < response.fields.length; i++) {
          if (response.fields[i].name === 'json') {
            obj = JSON.parse(response.fields[i].value);
            return {
              data: obj,
            };
          }
        }

        return {
          data: obj,
        };
      });
    },

    getMany: (resource, params) => {
      const url = `${mapping[resource]}/${resource}?ids=${params.ids.join(',')}`;
      return remote.get(url).then(response => {
        return {
          data: response.data.map(x => {
            return {
              ...x,
              id: x.id,
            };
          }),
          total: response.data.length,
        };
      });
    },

    getManyReference: (resource, params) => {
      return null;
    },

    update: (resource, params) => {
      const formData = createFormData(params);

      return remote
        .put(`${mapping[resource]}/${resource}/${params.data.id}`, formData)
        .then(response => {
          return createSaveResponse(response);
        });
    },

    updateMany: (resource, params) => {
      const formData = createFormData(params);
      formData.append('ids', params.ids.join(','));

      return remote.put(`${mapping[resource]}/${resource}`, formData).then(response => {
        return createSaveResponse(response);
      });
    },

    create: (resource, params) => {
      const formData = createFormData(params);

      return remote.post(`${mapping[resource]}/${resource}`, formData).then(response => {
        return createSaveResponse(response);
      });
    },

    delete: (resource, params) => {
      const { id, previousData } = params;

      return remote.delete(`${mapping[resource]}/${resource}/${id}`).then(() => ({ previousData }));
    },

    deleteMany: (resource, params) => {
      const formData = new FormData();
      formData.append('ids', JSON.stringify(params.ids));
      return remote
        .deleteMany(`${mapping[resource]}/${resource}`, formData)
        .then(() => ({ data: params }));
    },
  };
};
